
import { CORE_API_ENDPOINT } from '../lib'
import MyManager from '../core/business/MyManager'

export default class RoomManager extends MyManager {
	async findAllRoom(data) {
		try {
			const options = {
				method: this.requestMethod.GET,
				url: `${CORE_API_ENDPOINT}/rooms/search`,
				data: data,
			}

			let res = await this.requestAction(options, null)

			return res
		} catch (error) {
			return false
		}
	}
}


// WEBPACK FOOTER //
// ./src/business/RoomManager.js